// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.object("TournamentResult", {
  id: __t.u64(),
  tournamentId: __t.u64(),
  placement: __t.u32(),
  userId: __t.u64(),
  username: __t.string(),
  bestTimeMs: __t.u32(),
  coinsAwarded: __t.i64(),
  itemAwarded: __t.option(__t.u64()),
  createdAt: __t.u64(),
});


